module.exports = __webpack_public_path__ + "static/media/logo.2887ba2b.png";